export const routeFactory = (root = "/") => ({
    "accountRenewal": `${root}account-renewal`,
    "appLookup": `${root}app-lookup`,
    "confirmationPage": `${root}confirmation`,
    "landingPage": `${root}index.html`,
    "manualSignUp": `${root}manual-signup`,
    "physicianLookup": `${root}physician-lookup`,
});
